package meineglasfaser.api.ubl

import com.ionspin.kotlin.bignum.serialization.kotlinx.humanReadableSerializerModule
import kotlinx.serialization.json.Json

val UBLJsonConfig = Json {
    serializersModule = humanReadableSerializerModule
}
